module.exports = __webpack_public_path__ + "static/img/reinforced-iron-plate_256.52932d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reinforced-iron-plate_256.png
// module id = mWW8
// module chunks = 0